import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

// loading
jQuery(function ($) {
	var webStorage = function () {
		if (sessionStorage.getItem('access')) {
			$('.loading').css({ 'display': 'none','opacity': '0', 'visibility': 'hidden', 'z-index': '-999999' });
		} else {
			setTimeout(function () {
				$('.loading').fadeIn(0);
			}, 0);
			setTimeout(function () {
				$('.loading__txt').addClass('is-on');
			}, 800);
			setTimeout(function () {
				$('.loading__txt').removeClass('is-on');
			}, 3400);
			setTimeout(function () {
				$('.loading__logo').addClass('is-on');
			}, 5000);
			setTimeout(function () {
				$('.loading').fadeOut(2800);
			}, 8500);
			sessionStorage.setItem('access', 'true');
		}
	}
	webStorage();
});

gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

	gsap.to('.topVision-bg', {
		autoAlpha : 1,
		scale: 1,
		delay: 0,
		duration: 1.6,
		scrollTrigger: {
			 trigger: '.topVision',
			 start: '-50px 70%',
			//  markers: true,
		},
	});

	gsap.to('.topVision__ttl', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: .5,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topVision',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.topVision__subTtl', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 1,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topVision',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.topVision__txt', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 1.5,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topVision',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.topVision__logo', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 2,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topVision',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.topService-txtBox-list', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 1,
		duration: 1.4,
		scrollTrigger: {
			 trigger: '.topService',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.topService-imgBox img', {
		autoAlpha : 1,
		scale: 1,
		delay: .8,
		duration: 1.4,
		scrollTrigger: {
			 trigger: '.topService',
			 start: 'top 70%',
			//  markers: true,
		},
	});

	gsap.to('.js-serviceItem', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: .6,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topService-list',
			 start: '-20% 70%',
			//  markers: true,
		},
		stagger: {
			from: "start",
			amount: 1.4,
		}
	});

	gsap.to('.js-newsItem', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: .6,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.js-trigger-news01',
			 start: '-20% 70%',
			//  markers: true,
		},
		stagger: {
			from: "start",
			amount: 1.4,
		}
	});

	gsap.to('.topRecruit__txt', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 0,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.topRecruit',
			 start: '20% 70%',
			//  markers: true,
		},
	});

	gsap.to('.js-recruitItem', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: .6,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.js-trigger-recruit01',
			 start: '-20% 70%',
			//  markers: true,
		},
		stagger: {
			from: "start",
			amount: 1.2,
		}
	});

	gsap.to('.js-noteItem', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: .6,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.js-trigger-note01',
			 start: '-20% 70%',
			//  markers: true,
		},
		stagger: {
			from: "start",
			amount: 1.4,
		}
	});

	gsap.to('.cmn-contactSec__txt', {
		autoAlpha : 1,
		transform: 'translateY(0)',
		delay: 0,
		duration: 1.2,
		scrollTrigger: {
			 trigger: '.cmn-contactSec',
			 start: '20% 70%',
			//  markers: true,
		},
	});

	Array.prototype.slice.call(document.querySelectorAll('.cmn-ttl01'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-20% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

	Array.prototype.slice.call(document.querySelectorAll('.cmn-ttl02'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-200% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

	Array.prototype.slice.call(document.querySelectorAll('.js-bt'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-140px 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

});
